module.exports = __webpack_public_path__ + "img/common-avatar.6d48f5cb.svg";